module.exports = __webpack_public_path__ + "img/maintenance_bg.207010c9.svg";